RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Overview = RivalIQ.views.ItemView.mixin({
        className: 'profile-overview',
        template: '#insightsProfileOverviewTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            normalizeHeights: RivalIQ.apps.Dashboard.mixins.NormalizeHeights
        },

        dashboardModelEvents: {
            'change:timePeriod': 'reload'
        },

        getMetaMetrics: function () {
            const me = this;
            let metaMetrics = [
                {
                    property: 'presence_handle',
                    dimensions: ['timeAnalysisMode', 'companyId', 'channel'],
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                },
                {
                    property: 'icon_url',
                    dimensions: ['timeAnalysisMode', 'companyId', 'channel'],
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                },
                {
                    property: 'overview',
                    dimensions: ['timeAnalysisMode', 'companyId', 'channel'],
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                }
            ];

            // NOTE for the time being it seems like we have to modify the meta
            // metrics by channel rather than use inheritance (i.e., to create
            // a channel specific overview class) so that we have compatibility
            // with Custom Dashboards
            const channel = me.getProp('channel');
            if (channel === RivalIQ.enums.channels.TWITTER) {
                metaMetrics = metaMetrics.concat([
                    {
                        property: 'location',
                        dimensions: ['timeAnalysisMode', 'companyId', 'channel'],
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                    },
                    {
                        property: 'url',
                        dimensions: ['timeAnalysisMode', 'companyId', 'channel'],
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                    },
                    {
                        property: 'joined_at',
                        dimensions: ['timeAnalysisMode', 'companyId', 'channel'],
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                    }
                ]);
            }

            return metaMetrics;
        },

        getMetrics: function () {
            const me = this;
            return {
                meta: me.getMetaMetrics(),
                metrics: _.reduce(me.getProp('metrics'), function (memo, metric) {
                    return memo.concat(metric, RivalIQ.metric.build(metric, {
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_ABSOLUTE,
                        valueFormat: function (value) {
                            return RivalIQ.formatter.changeSignPrefix(value) + RivalIQ.formatter.formatAbbreviated(value);
                        }
                    }));
                }, [])
            };
        },

        loadData: function () {
            const me = this;

            const props = me.getProps();
            const collections = _.reduce(me.getMetrics(), function (memo, value, key) {
                return _.set(memo, key, new RivalIQ.collections.MetricDefinitions(
                    _.map(value, function (metric) {
                        return RivalIQ.metric.build(metric, props);
                    })
                ));
            }, {});

            const deferreds = _.map(collections, function (collection) {
                return collection.fetch();
            });

            return $.when.apply($, deferreds)
                .done(function () {
                    const keys = _.keys(collections);
                    me.metricsCollections = _.reduce(arguments, function (memo, collection, idx) {
                        return _.set(memo, keys[idx], collection);
                    }, {});
                });
        },

        templateHelpers: function () {
            const me = this;
            return _.defaults({
                emojify: RivalIQ.utils.emoji.emojify,
                // NOTE this is another case where we need to handle how to
                // get information by channel (in this case the link to the
                // profile corresponding the presence)
                getPresenceProfileUrl: function (metric) {
                    const channel = metric.get('channel');
                    if (channel === RivalIQ.enums.channels.TWITTER) {
                        const handle = _.last(_.flatten(metric.getValue({
                            format: false
                        })));
                        return ['https://twitter.com', handle].join('/');
                    }
                    return '';
                },
                getMetricIcon: function (metric) {
                    return ['fa', RivalIQ.metric.search.getPropertyValue(metric.attributes, 'icon', metric.data)].join('-');
                },
                getMetricHandle: function (metric) {
                    let value = metric.getValue({
                        format: true
                    });
                    if (_.isArray(value)) {
                        value = _.head(_.flatten(value));
                    }
                    return value;
                },
                getMetricMetadataHtml: function (metric) {
                    const value = metric.getValue({
                        format: false
                    });

                    let text = value;
                    if (_.isArray(value)) {
                        text = _.head(_.flatten(value));
                    }

                    if (!text) {
                        const name = metric.getName();
                        return `[ no ${name} available ]`;
                    }

                    return metric.getValue({
                        format: true,
                        html: true
                    });
                },
                getMetricDescriptionText: function (metric) {
                    const value = metric.getValue({
                        format: false
                    });

                    let text = value;
                    if (_.isArray(value)) {
                        text = _.head(_.flatten(value));
                    }

                    if (!text) {
                        const name = metric.getName();
                        return `[ This account does not have a ${name}. ]`;
                    }

                    return text;
                },
                getMetricPopoverContent: function (metric) {
                    return $.tagHtml('div', {
                        class: ['widget-insights-summary-tooltip', 'columnar', 'clearfix'],
                        html: [
                            $.tagHtml('div', {
                                class: 'pull-left',
                                html: [
                                    $.tagHtml('p', {
                                        class: 'metric-label',
                                        text: metric.getName({
                                            abbreviate: true
                                        })
                                    }),
                                    $.tagHtml('h1', {
                                        class: 'metric-value',
                                        text: metric.getValue({
                                            format: true,
                                            expand: true,
                                            abbreviate: false
                                        })
                                    })
                                ].join('')
                            })
                        ].join('')
                    });
                },
                getMetricAbsoluteChangeClass: function (metric) {
                    let value = metric.getValue({
                        format: false
                    });

                    if (_.isArray(value)) {
                        value = _.last(_.flatten(value));
                    }

                    if (value > 0) {
                        return 'metric-positive';
                    }

                    if (value < 0) {
                        return 'metric-negative';
                    }

                    return '';
                },
                metrics: me.metricsCollections.metrics.groupBy(function (item, idx) {
                    return Math.floor(idx / 2);
                })
            }, me.metricsCollections);
        },
        onRenderLoaded: function () {
            const me = this;
            me.$('[data-toggle="popover"]').popover({
                container: 'body',
                html: true
            });
        }
    });

    const OverviewWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        title: 'Overview',
        description: RivalIQ.strings.profile_overview_description,
        view: Overview,
        viewMore: false,
        scheduledExportAdvancedSettingsEnabled: false,
        getFilename: function () {
            const me = this;
            const companyId = me.getProp('companyId');
            const company = RivalIQ.state.landscape.getCompanyById(companyId);
            return RivalIQ.export.filename.base({
                title: 'Overview',
                companyName: company.get('name')
            });
        },
        allowPageBreaks: function () {
            const me = this;
            const limit = me.getProp('limit');
            return limit === -1;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSIGHTS_PROFILE_OVERVIEW, OverviewWidget);

});
